import { __decorate } from "tslib";
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import ActionButton from '@/components/action_button/Index.vue';
import { Getter, Mutation } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { required } from 'vuelidate/lib/validators';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import jntAccountCreate from '@/plugins/graphql/mutations/v2/jnt-account-create.gql';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { requiredProperty } from '@/helpers/mixins/LocalizationHelper';
import { validationMixin } from 'vuelidate';
import JntDetails from '@/plugins/graphql/queries/v2/jnt-account.gql';
import { JntAccountInputModel } from '@/helpers/entities/models/JntAccountInputModel';
let JntExpressActivationForm = class JntExpressActivationForm extends Mixins(validationMixin, ViewportSizeMixin, RouterParamsAppMixin, CleverTapEventsMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.isVisible = false;
        this.form = {
            customerId: '',
        };
    }
    toggleForm() {
        this.isVisible = true;
    }
    mounted() {
        if (this.formData) {
            this.form = { ...this.formData };
        }
    }
    onJntAccountChange(newVal) {
        if (newVal) {
            this.form.customerId = newVal.customerId || '';
        }
    }
    onCancel() {
        this.isVisible = false;
    }
    get customerIdErrors() {
        const errors = [];
        if (!this.$v.form.customerId.$dirty) {
            return errors;
        }
        if (!this.$v.form.customerId.required) {
            const msg = requiredProperty('Customer ID');
            errors.push(msg);
        }
        return errors;
    }
    onSubmit() {
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }
        this.requestOnFlight();
        this.create()
            .then(() => {
            this.successNotification('J&T Account Validation Sent');
            this.isVisible = false;
        })
            .catch((err) => {
            this.errorNotification(err.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async create() {
        try {
            const response = await this.$apollo.mutate({
                mutation: jntAccountCreate,
                variables: {
                    input: {
                        appUuid: this.appUuid,
                        customerId: this.form.customerId,
                    },
                },
                refetchQueries: [
                    {
                        query: JntDetails,
                        variables: {
                            appUuid: this.appUuid,
                        },
                    },
                ],
            });
        }
        catch (error) {
            console.error('Submission failed:', error);
            throw error;
        }
    }
};
__decorate([
    Prop({ type: String })
], JntExpressActivationForm.prototype, "appUuid", void 0);
__decorate([
    Prop({ type: Object })
], JntExpressActivationForm.prototype, "jntAccount", void 0);
__decorate([
    Watch('jntAccount', { immediate: true })
], JntExpressActivationForm.prototype, "onJntAccountChange", null);
__decorate([
    Getter('requestOnFlight')
], JntExpressActivationForm.prototype, "requestCurrentlyOnFlight", void 0);
__decorate([
    Mutation('requestOnFlight')
], JntExpressActivationForm.prototype, "requestOnFlight", void 0);
__decorate([
    Mutation('requestDone')
], JntExpressActivationForm.prototype, "requestDone", void 0);
JntExpressActivationForm = __decorate([
    Component({
        components: {
            PageTitle,
            ActionButton,
            BaseTextField,
        },
        apollo: {
            jntAccount: {
                query: JntDetails,
                variables() {
                    const appUuid = this.appUUID;
                    return {
                        appUuid,
                    };
                },
                update(data) {
                    return new JntAccountInputModel(data.fetchJntAccount);
                },
            },
        },
        validations: {
            form: {
                customerId: { required },
            },
        },
    })
], JntExpressActivationForm);
export default JntExpressActivationForm;
